import { render, staticRenderFns } from "./ModalWaiting.vue?vue&type=template&id=244360d2&scoped=true&"
var script = {}
import style0 from "./ModalWaiting.vue?vue&type=style&index=0&id=244360d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244360d2",
  null
  
)

export default component.exports